import { changeEnvUrl, getAppEnv } from '@qm-activity/common/assets/ts/utils';
import { apiMap } from '@qm-activity/common/assets/ts/const';
import { useStoreCommon } from '@qm-activity/common/store/common';
import Vue from 'vue';
import { FreereaderRequest, IOptionsConfig, IRetryConfig } from '@q-front-npm/request';
import { jsbSupportMap, redirectWebview } from '@q-front-npm/jsbridge';
import { openLogin } from '@q-front-npm/jsbridge';
const isDev = import.meta.env.VITE_ENV === 'dev';
const isProd = import.meta.env.VITE_ENV === 'production';
const isTest = import.meta.env.VITE_ENV === 'test';
const retryingUrl: string[] = [];
// 当前debug包所处环境
const testEnv = getAppEnv();
const requestConfig: IOptionsConfig = {
    isDev,
    apiMap,
    toastFn: (msg: string) => {
        Vue.prototype.$toast(msg);
    },
    withCredentials: false,
    useJsb: !isDev,
    isCrypt: false,
    timeout: 10000,
    requestInterceptors: async(config: Record<string, any>) => {
        const storeCommon = useStoreCommon();
        if (isDev || isTest) {
            config.params = { ...config.params, testuid: storeCommon.urlParams.uid, test_uid: storeCommon.urlParams.uid, };
        }
        if (isDev) {
            config.headers = {
                ...config.headers,
                'app-version': '999999999',
            };
        }
        // 只有在debug包中客户端才会加入test-env头部字段test-env
        if (testEnv && !isProd) {
            // 添加header头标识哪个环境
            config.headers = {
                ...config.headers,
                'test-env': testEnv,
            };
            const reg = /^http[\s\S]+/;
            // 无域名请求（直接以当前域名为baseURL请求）
            if (reg.test(config.url || '') || reg.test(config.baseURL || '')) {
                config.baseURL = changeEnvUrl(config.baseURL || '');
                config.url = changeEnvUrl(config.url || '');
            }
        }
        return config;
    },
    responseInterceptors: (res: Record<string, any>) => {
        // console.log('-- res', res);
        const storeCommon = useStoreCommon();
        storeCommon.setPageLoading(false);
        const { data, errors, } = res.data;
        if (data) {
            return data;
        }
        if (errors?.code == '44020012') {
            location.replace(`${window.location.origin}/h5/activity/freereaderMarathon2026/sidePanel/index?full_screen=3`);
            // 兜底，如果800ms后没有跳转，则再跳转一次
            setTimeout(() => {
                location.replace(`${window.location.origin}/h5/activity/freereaderMarathon2026/sidePanel/index?full_screen=3`);
            }, 800);
            return Promise.reject(res);
        }
        if (errors?.code === '44010118' && !storeCommon.systemInfo.isHarmony) {
            openLogin();
        }
        return Promise.reject(res);
    },
    requestInterceptorsError: (err: any) => {
        // console.log('-- request error', err);
        return Promise.reject(err);
    },
    responseInterceptorsError: (err: any) => {
        // console.log('-- response error', err);
        const storeCommon = useStoreCommon();
        storeCommon.setPageLoading(false);
        return Promise.reject(err);
    },
    retrying: (config: IRetryConfig) => {
        const inRetryingUrl = retryingUrl.some((url) => (config?.url || '').indexOf(url) > -1);
        if (inRetryingUrl) {
            console.log('-- retrying', config.retryEnd, config.isSuccess);
        }
    },
};

const request = new FreereaderRequest(requestConfig);

export const get = (url: string, params: Record<string, any> = {}, config: Record<string, any> = {}) => {
    return request.get(url, params, config);
};

export const post = (url: string, params: Record<string, any> = {}, config: Record<string, any> = {}) => {
    return request.post(url, params, config);
};

export const postForm = (url: string, params: Record<string, any> = {}, config: Record<string, any> = {}) => {
    return request.postForm(url, params, config);
};
